import { isProduction } from 'services/configService';
import FRPro from 'assets/app_switcher/FRPro.svg';
import App_brandmarks_SuF from 'assets/app_switcher/App_brandmarks_SuF.svg';
import CorporateBankerHub from 'assets/app_switcher/CorporateBankerHub.svg';
import BMI from 'assets/app_switcher/BMI.svg';
import BMI_GEO_SIGNALS_LOGO from 'assets/general/Logo_Geo_Risk_Signals_App_Switcher.svg';

const BMI_APP = {
    key: 'BMI',
    name: 'BMI',
    image: <img src={BMI} alt="Logo BMI" width="40" height="40" />,
};

const FRP_APP = {
    key: 'FRP',
    name: 'Fitch Ratings PRO',
    image: (
        <img src={FRPro} alt="Logo Fitch Ratings PRO" width="40" height="40" />
    ),
};

const SUSTAINABLE_FITCH_APP = {
    key: 'SUSTAINABLE_FITCH',
    name: 'Sustainable Fitch',
    image: (
        <img
            src={App_brandmarks_SuF}
            alt="Logo Sustainable Fitch"
            width="40"
            height="40"
        />
    ),
};

const CORP_HUB_APP = {
    key: 'CORP_HUB',
    name: 'Corporate Banker Hub',
    image: (
        <img
            src={CorporateBankerHub}
            alt="Logo Corporate Banker Hub"
            width="40"
            height="40"
        />
    ),
};

//@ts-ignore
// todo: verify if this needs to be visible
const BMI_GEO_RISK_SIGNALS_APP = {
    key: 'BMI_GEO_RISK_SIGNALS',
    name: 'BMI Geo Risk Signals',
    uri: 'https://app.bmigeorisksignals.com',
    image: (
        <img
            src={BMI_GEO_SIGNALS_LOGO}
            alt="Logo BMI Geo Risk Signals"
            width="40"
            height="40"
        />
    ),
};

const PRODUCTION_APPS = [
    { ...BMI_APP, url: 'https://bmi.fitchsolutions.com/' },
    { ...FRP_APP, url: 'https://pro.fitchratings.com/' },
    { ...SUSTAINABLE_FITCH_APP, url: 'https://pro.sustainablefitch.com' },
    { ...CORP_HUB_APP, url: 'https://corporatehub.fitchratings.com' },
    // todo: verify if this needs to be visible
    //BMI_GEO_RISK_SIGNALS_APP,
];

const STAGING_APPS = [
    { ...BMI_APP, url: 'https://bmi-stg.fitchsolutions.com/' },
    { ...FRP_APP, url: 'https://pro-stg.fitchratings.com/' },
    { ...SUSTAINABLE_FITCH_APP, url: 'https://pro-stg.sustainablefitch.com' },
    { ...CORP_HUB_APP, url: 'https://corporatehub-stg.fitchratings.com' },
    // todo: verify if this needs to be visible
    //BMI_GEO_RISK_SIGNALS_APP,
];
export const getUserAppSwitcherOptions = (user_accessible_apps: string[]) => {
    if (!user_accessible_apps) {
        return [];
    }
    const apps = isProduction() ? PRODUCTION_APPS : STAGING_APPS;
    return apps.filter(app => user_accessible_apps.includes(app.key));
};
